import {HttpClient} from "../../service/httpClient/HttpClient";
import moment from "jalali-moment";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import axios from "axios";

export class TransactionsService {
    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getCostsAndRevenues(
        page,
        searchName,
        filterStartDate,
        filterEndDate,
        filterTag,
        filterType,
        filterCategory,
        size = 20) {

        const costsAndRevenuesListRequest = this.httpClient.get(
            `fund-presentation/funds/${this.fundID}/costs-and-revenues`,
            this.httpClient.prepareUserAccessHeader(this.token),
            {
                page: page,
                size: size,
                title: searchName,
                "start-date": filterStartDate && filterStartDate.length === 10 ? moment.from(filterStartDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : "",
                "end-date": filterEndDate && filterEndDate.length === 10 ? moment.from(filterEndDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : "",
                "tag-id": filterTag && filterTag >= 0 ? filterTag : "",
                "category-id": filterCategory && filterCategory >= 0 ? filterCategory : "",
                kind: filterType
            }
        )

        const constAndRevenuesStatusRequest = this.httpClient.get(
            `fund-presentation/funds/${this.fundID}/costs-and-revenues/report-status`,
            this.httpClient.prepareUserAccessHeader(this.token)
        )


        return new Promise((resolve, reject) => {
            axios.all([costsAndRevenuesListRequest, constAndRevenuesStatusRequest])
                .then(axios.spread((costsAndRevenuesListResponse, constAndRevenuesStatusResponse) => {
                    resolve({
                        costsAndRevenuesListResponse,
                        constAndRevenuesStatusResponse
                    })
                }))
                .catch(reject)
        })
    }

    prepareTransactionData(amount, title, date, transactionKind, enabled, description, tagId, selectedCategoryId) {
        return {
            "amount": amount,
            "title": title,
            "description": description,
            "enabled": enabled,
            "kind": transactionKind,
            "payAt": moment.from(date, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD'),
            tagId: tagId > 0 ? tagId : "",
            activeCategories: selectedCategoryId && selectedCategoryId !== -1 ? [selectedCategoryId] : []
        }
    }

    addNewTransaction(transactionData, clearFields) {
        this.loading(setLoadingStateDispatch(true))
        this.httpClient.post(
            `fund-presentation/funds/${this.fundID}/costs-and-revenues`,
            transactionData,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {
            clearFields()
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تراکنش جدید با موفقیت افزوده شد!"))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در افزودن تراکنش جدید!"))
            this.loading(setLoadingStateDispatch(false))
        })
    }

    getTransactionDetail(fundID, transactionId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/costs-and-revenues/${transactionId}`,
                this.httpClient.prepareUserAccessHeader(this.token),
            ).then(resolve).catch(reject)
        })
    }

    updateTransaction(transactionId, transactionData) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            `fund-presentation/funds/${this.fundID}/costs-and-revenues/${transactionId}`,
            this.httpClient.prepareUserAccessHeader(this.token),
            transactionData
        ).then(response => {

            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروز رسانی تراکنش با موفقیت انجام شد!"))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {

            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در بروزرسانی اطلاعات تراکنش!"))
            this.loading(setLoadingStateDispatch(false))
        })
    }

    deleteTransaction(transactionId) {
        return new Promise((resolve, reject) => {
            this.httpClient.delete(
                `fund-presentation/funds/${this.fundID}/costs-and-revenues/${transactionId}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(response => {
                resolve(response)
            }).catch(reject)
        })
    }
}


export const transactionTypes = {
    ALL: {
        id: "",
        type: "All",
        title: "همه"
    }, COSTS: {
        id: "COSTS",
        type: "COSTS",
        title: "هزینه ها"
    }, REVENUES: {
        id: "REVENUES",
        type: "REVENUES",
        title: "درآمد ها"
    },

}